// extracted by mini-css-extract-plugin
export default {"question":"Question_question__ZumRa","questionTitle":"Question_questionTitle__pqLeC","questionImg":"Question_questionImg__YGjAN","questionsShots":"Question_questionsShots__6ca89"};